export const STAMPER_CARD = 'stamper-card';

export enum STAMPER_CARD_TYPES {
    active = 'active',
    expired = 'expired'
}
